import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, IconButton, InputAdornment, List, ListItem, ListItemText, Paper, TextField } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from 'react-i18next';
import OutlinedButton from '../../shared/Button/customOutlinedButton';
import { useState } from 'react';
import SearchIcon from "@mui/icons-material/Search";

type PopUpProps = {
    open: boolean;
    handleClose: () => void;
    participantList: any
};

export default function SelectedParticipantListPopUp(props: PopUpProps) {
    const { open, handleClose, participantList } = props;
    const { t } = useTranslation();
    const translate = t as (key: string) => string;

    const [search, setSearch] = useState('');
    // Exclude "All Participants" from displayed entries
    const filtered = participantList
        .filter((p: string) => p.toLowerCase().includes(search.toLowerCase()))
        .filter((p: string) => p.toLowerCase() !== "all participants");
    return (
        <Dialog
            open={open}
            onClose={handleClose}   
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{ '& .MuiDialog-paper': { minWidth: '25%' } }}
        >
            <DialogTitle sx={{
                backgroundColor: "#059ca9",
                color: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '10px 10px'
            }}>
                {"Participants"}

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        color: "white",
                        padding: '0px'
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent style={{ paddingTop: '20px' }}>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{
                        whiteSpace: 'normal', // allow wrapping
                        overflowWrap: 'break-word', // break long words
                        wordBreak: 'break-word', // ensure long words wrap
                        fontSize: '1rem'
                    }}
                > 
                    <>
                        <TextField
                            placeholder="Search List"
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            fullWidth
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ marginBottom: 1, background: "#F6F7F9" }}
                        />
                        <Paper sx={{ height: 330, overflow: "auto", background: "#F6F7F9" }}>
                            <List dense component="div" role="list" sx={{ paddingTop: "0px" }}>
                                {filtered.map((p: any, idx: any) => (
                                    <ListItem key={idx}>{p}</ListItem>
                                ))}
                            </List>
                        </Paper>
                    </>
                </DialogContentText>
            </DialogContent>
            <Divider />
            <DialogActions>
                <DialogActions sx={{ padding: '0px' }}>
                    <OutlinedButton onClick={handleClose}>
                        {translate('close')}
                    </OutlinedButton>
                </DialogActions>
            </DialogActions>
        </Dialog>
    );
}
